<div class="merge-task-content">
  <div class="stepper-header">
    @for (s of steps; track s.step; let i = $index) {
    <div class="step-item" [class.active]="currentStep === s.step" [class.completed]="currentStep > s.step">
      <div class="step-circle">{{ i + 1 }}</div>
      <div class="step-text">
        <span class="step-label">{{ s.label }}</span>
        <span class="step-sublabel">{{ s.subtitle }}</span>
      </div>
      @if (i < steps.length - 1) {
      <div class="step-connector"></div>
      }
    </div>
    }
  </div>

  @if (warningMessage) {
  <div class="warning-message">
    <span>{{ warningMessage }}</span>
    <button
      type="button"
      class="warning-close-btn"
      aria-label="Close warning"
      (click)="dismissWarning()">
      <i class="pi pi-times"></i>
    </button>
  </div>
  }

  @if (currentStep === MergeTaskStep.SelectTask) {
  <div class="step-body">
    <div class="target-task-info-strip">
      <span class="target-task-info-item">
        <span class="target-task-info-label">Target Task Point:</span>
        <span class="target-task-info-value">{{ targetTask?.task_point_name || 'NA' }}</span>
      </span>
      <span class="target-task-info-divider">|</span>
      <span class="target-task-info-item">
        <span class="target-task-info-label">Target Address:</span>
        <span class="target-task-info-value">{{ targetTask?.address || 'NA' }}</span>
      </span>
    </div>
    <app-merge-task-table
      #mergeTaskTable
      [routeName]="routeDetails?.route_label"
      [tasks]="routeTasks"
      [loading]="loading"
      [selectedTasks]="selectedTasks"
      (selectionChange)="onTasksSelected($event)">
    </app-merge-task-table>
  </div>
  }

  @if (currentStep === MergeTaskStep.SelectTarget) {
  <div class="step-body">
    <app-merge-task-table
      [routeName]="routeDetails?.route_label"
      [tasks]="targetTaskSelection"
      [loading]="loading"
      selectionMode="single"
      [selectedTasks]="targetTask ? [targetTask] : []"
      (selectionChange)="onTargetTaskSelected($event)"
      [selectionSummary]="targetTask ? [targetTask] : []"
    >
    </app-merge-task-table>
  </div>
  }

  @if (currentStep === MergeTaskStep.Preview) {
  <div class="step-body">
    <h4>Preview & Confirm</h4>
    <app-merge-task-table
      [routeName]="routeDetails?.route_label"
      [tasks]="previewTableRows"
      selectionMode="single"
      [currentStep]="currentStep"
      [selectedTasks]="targetTask ? [targetTask] : []"
      [selectionDisabled]="true">
    </app-merge-task-table>
    @if (hasTimeWindowWarning) {
    <h5 class="warning-header"><i class="pi pi-exclamation-triangle"></i> Time Window Constrain Warning</h5>
    }
    @if (hasTimeWindowWarning) {
    <div class="preview-warning-box">
      <div class="preview-warning-subheader">
        <i class="pi pi-clock"></i>
        Time Window Conflict Detected
      </div>
      <div>{{ timeWindowWarningMessage }}</div>
    </div>
    }
  </div>
  }

  @if (currentStep === MergeTaskStep.Result) {
  <div class="step-body">
    <h4>Merge Result</h4>
    @if (isSuccess) {
    <div class="success-message">
      <span>
        <b>Success:</b> {{successMessage}}
      </span>
    </div>
    }
    @if (isSuccess === false) {
    <div class="error-message">
      <span><b>Error : </b> {{ errorMessage }}</span>
    </div>
    }

  </div>
  }

  <div class="step-footer">
    @if (currentStep === MergeTaskStep.SelectTarget) {
      <button class="pn-button pn-button-secondary pn-button-md me-2" (click)="cancel()">Cancel</button>
      <button class="pn-button pn-button-primary pn-button-md" (click)="next()" [disabled]="!targetTask">Continue to Source <img src="./assets/image/Arrow.svg" alt="arrow" height="15" width="15"></button>
    }
  
    @if (currentStep === MergeTaskStep.SelectTask) {
      <button class="pn-button pn-button-tertiary pn-button-md me-2" (click)="back()">Back</button>
      <button class="pn-button pn-button-secondary pn-button-md me-2" (click)="cancel()">Cancel</button>
      <button class="pn-button pn-button-primary pn-button-md" (click)="next()" [disabled]="!selectedTasks.length || !mergeTaskTable?.allSelectedValidForMerge">
        Continue to Preview <img src="./assets/image/Arrow.svg" alt="arrow" height="15" width="15"></button>
    }

    @if (currentStep === MergeTaskStep.Preview) {
      <button class="pn-button pn-button-tertiary pn-button-md me-2" (click)="back()">Back</button>
      <button class="pn-button pn-button-secondary pn-button-md me-2" (click)="cancel()">Cancel</button>
      <button class="pn-button pn-button-primary pn-button-md" (click)="confirm()" [disabled]="isFinalStepDisabled || loading">Confirm <img src="./assets/image/Arrow.svg" alt="arrow" height="15" width="15"></button>
    }

    @if (currentStep === MergeTaskStep.Result) {
      <button class="pn-button pn-button-primary pn-button-md" (click)="cancel()">Close</button>
    }
  </div>
</div>
